import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface UserState {
  user_id: number;
  email: string;
  // WC billing_* polja prosledjena iz WP SSO tokena.
  // Mogu biti undefined ako je nalog stariji od integracije
  // ili korisnik nije popunio polje (npr. legacy nalog).
  first_name?: string;
  last_name?: string;
  full_name?: string;     // convenience: "first_name last_name"
  phone?: string;
  address?: string;
  city?: string;
  postcode?: string;
  birthday?: string;      // YYYY-MM-DD, opciono (sad obavezno pri registraciji)
  loyalty_level: string;
  points: number;
  discount_value: number;
  discount_description: string;
  exp: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserStore {

  private userSubject = new BehaviorSubject<UserState | null>(null);

  user$ = this.userSubject.asObservable();

  setUser(user: UserState) {
    this.userSubject.next(user);
  }

  getUser(): UserState | null {
    return this.userSubject.getValue();
  }

  clear() {
    this.userSubject.next(null);
  }

}